<template>
  <img src="~BRAND/assets/google_fit.png" class="logo"/>
</template>

<script>
export default {
  name: 'GoogleFitLogo'
};
</script>

<style>
.logo{
  width: 43%;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/logo/GoogleFitLogo.vue